import type { DetailedHTMLProps, ImgHTMLAttributes } from "react";

import type { StyleXProps } from "@/styles/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export type ImageLoaderProps = StyleXProps<
    DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
>;

const sizes = [300, 360, 480, 533, 600, 800, 1000, 1200, 1280, 1400, 1600];

export default function ImageLoader({ src, width, styleX, alt, ...props }: ImageLoaderProps) {
    if (!alt) {
        console.warn("Missing alt for image with source", src);
    }

    let widthSize = "";

    if (width) {
        if (typeof width === "string") {
            width = Number.parseInt(width);
        }

        for (const size of sizes) {
            if (size >= width) {
                widthSize = `w=${size}`;
                break;
            }
        }
    }

    return (
        <picture>
            <source type="image/avif" srcSet={`${src}?${widthSize}&f=avif`} />
            <source type="image/webp" srcSet={`${src}?${widthSize}&f=webp`} />
            <img {...props} {...stylex.props(styles.image, styleX)} alt={alt} src={src} width={width} />
        </picture>
    );
}

const styles = stylex.create({
    image: {
        objectFit: "contain",
        maxWidth: "100%",
    },
});
